export default {
  allVehicleMovementRecords: [],
  vehicleMovementRecord: {},
}
